<template>
  <el-dialog
    custom-class="with-title x-large"
    title="ウィジェット作成"
    :visible.sync="visible"
    :before-close="beforeClose"
  >
    <div v-loading.fullscreen.lock="isSubmit">
      <div class="message message-info mb-x2">
        <div>ウィジェット表示フラグをONにした投稿がウィジェットに表示されます。</div>
        <div>最後にデータを作成・更新したときの設定が反映されます。</div>
        <div v-if="campaign.isWidgetCreated">
          ウィジェット表示フラグを変更した場合、都度 [ウィジェットデータの更新] をしてください。
        </div>
      </div>
      <div class="campaign-container mb-x2">
        <div class="description">下記手順を実施しコードを貼り付けると、Webページにウィジェットが表示されます。</div>
        <div class="description mb-x2">コードの貼り付けは初回だけ必要です。</div>
        <div class="form-label mb-x2">1. Webページにコードを貼り付け</div>
        <div class="description">ウィジェットを表示するウェブページのHTMLを開いてください。</div>
        <div class="description">
          <span class="text-bold" v-text="'</head>'"></span>タグの上に下記コードを貼り付けてください。
        </div>
        <el-input
          class="mt-x2 mb-x2 no-resize"
          v-if="campaign.isWidgetCreated"
          type="textarea"
          :value="headCode"
          :readonly="true"
          :rows="textarea_rows"
        ></el-input>
        <div class="message message-warning mt-x2 mb-x2" v-else>
          ウィジェットデータの生成ボタンをクリックしてください。
        </div>
        <div class="form-label mb-x2">2. ウィジェット表示箇所にコードを貼り付け</div>
        <div class="description">ウェブページのウィジェットを表示する箇所に下記コードを貼り付けてください。</div>
        <el-input
          class="mt-x2 no-resize"
          v-if="campaign.isWidgetCreated"
          type="textarea"
          :value="widgetCode"
          :rows="1"
          :readonly="true"
        ></el-input>
        <div class="message message-warning mt-x2" v-else>ウィジェットデータの生成ボタンをクリックしてください。</div>
      </div>
      <div class="campaign-container mb-x2">
        <div class="form-label mb-x1">表示件数</div>
        <el-input-number
          style="width: 100px"
          type="number"
          :min="1"
          controls-position="right"
          v-model="defaultLimitCount"
          :max="maxLimitCount"
          @change="handleDefaultLimitCount"
        ></el-input-number>
        <div class="form-label mt-x2 mb-x1">続きを表示ボタンのテキスト</div>
        <el-input class="loadmore-text" v-model="loadMoreText" @input="onChangeLoadMoreText"></el-input>
        <div class="mt-x2 mb-x1" style="display: flex">
          <el-switch v-model="isViewMessage" active-text="投稿内容を表示"></el-switch>
        </div>
        <div class="description">ONにすると投稿内容が表示されます。</div>
        <el-button class="mt-x2" type="primary" @click="createWidget">
          <div v-if="!campaign.isWidgetCreated">
            <div class="mdi mdi-cloud-upload"></div>
            ウィジェットデータの生成
          </div>
          <div v-else>
            <div class="mdi mdi-cloud-upload"></div>
            ウィジェットデータの更新
          </div>
        </el-button>
      </div>
      <div class="preview">
        <div class="caption">プレビュー</div>
        <div class="mt-x2" v-if="campaign.isWidgetCreated">
          <widget-preview-grid
            v-if="widgets.length && !isViewMessage"
            :posts="preview_widgets"
            :snsType="snsType"
          ></widget-preview-grid>
          <widget-preview-message
            v-if="widgets.length && isViewMessage"
            :posts="preview_widgets"
            :isViewMessage="isViewMessage"
            :snsType="snsType"
            :displayCount="displayCount"
          ></widget-preview-message>
          <div class="message message-info" v-if="!widgets.length">ウィジェットが選択されていません。</div>
          <div class="button-container mt-x2" v-if="widgets.length > 0 && displayCount < widgets.length">
            <el-button size="large" type="primary" @click="clickLoadMore">{{ loadMoreText }}</el-button>
          </div>
        </div>
        <div class="message message-warning mt-x2" v-else>ウィジェットデータの生成ボタンをクリックしてください。</div>
      </div>
    </div>
  </el-dialog>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import WidgetPreviewGrid from '@/client/components/_atoms/widget_preview_grid'
import WidgetPreviewMessage from '@/client/components/_atoms/widget_preview_message'
import api from '@/client/core/api'
import { TrackingService } from '@/client/services'

export default defineComponent({
  components: {
    WidgetPreviewGrid,
    WidgetPreviewMessage
  },

  props: {
    campaign: Object
  },

  data() {
    return {
      visible: false,
      loadMoreText: '続きを表示',
      defaultLimitCount: 12,
      maxLimitCount: 32,
      headCode: '',
      widgetCode: '',
      widgets: [],
      isSubmit: false,
      displayCount: 12,
      isViewMessage: false
    }
  },

  watch: {
    loadMoreText: function () {
      this.renderCode()
    },
    defaultLimitCount: function () {
      this.renderCode()

      this.displayCount = this.defaultLimitCount
    },
    isViewMessage: function () {
      this.renderCode()

      this.displayCount = this.defaultLimitCount
    },
    'campaign.isWidgetCreated': function () {
      this.renderCode()
    }
  },

  computed: {
    preview_widgets() {
      return this.widgets.slice(0, this.displayCount)
    },
    textarea_rows() {
      if (this.campaign.isWidgetCreated) {
        return 13
      }

      return 1
    },
    snsType() {
      return this.campaign.snsType
    }
  },

  methods: {
    /**
     * ダイアログを開く
     */
    open() {
      this.visible = true

      if (this.campaign.isWidgetCreated === 1) {
        this.renderCode()

        this.getWidgets()
      } else {
        this.headCode = 'ウィジェットデータを生成するため、上記ウィジェットデータの作成ボタンをクリックしてください。'
        this.widgetCode = 'ウィジェットデータを生成するため、上記ウィジェットデータの作成ボタンをクリックしてください。'
      }
    },

    /**
     * コードをレンダリング
     * script の閉じタグは、SFC の script ブロックの終端と解釈されないよう文字列を分割している
     */
    async renderCode() {
      let headCode = '<!-- ATELU Widget Code -->\n'
      headCode += '<script>\n'
      headCode += '(function(d, s, id) {\n'
      headCode += '  var js, fjs = d.getElementsByTagName(s)[0];\n'
      headCode += '  if (d.getElementById(id)) return;\n'
      headCode += '  js = d.createElement(s); js.id = id;\n'
      headCode += "  js.src = 'https://widget-atelu.comnico.jp/widget.js';\n"
      headCode += '  fjs.parentNode.insertBefore(js, fjs);\n'
      headCode += "}(document, 'script', 'atelu-widget-js'));\n"
      headCode += '</' + 'script>\n'
      headCode += '<!-- End ATELU Widget Code -->'

      if (this.isViewMessage) {
        headCode += '\n\n'
        headCode += '<!-- Widget Settings https://github.com/bigbite/macy.js -->\n'
        headCode += '<script>\n'
        headCode += ' window.widgetMacySetting = {\n'
        headCode += '   margin: {\n'
        headCode += '     x: 8,\n'
        headCode += '     y: 8\n'
        headCode += '   },\n'
        headCode += '   columns: 4,\n'
        headCode += '   breakAt: {\n'
        headCode += '     "768": 2\n'
        headCode += '   }\n'
        headCode += ' }\n'
        headCode += '</' + 'script>\n'
        headCode += '<!-- End Widget Settings -->'
      }
      this.headCode = headCode

      let widgetCode = `<div class="atelu_widget" id="atelu_widget_${this.campaign.hash}"`

      if (this.loadMoreText !== '続きを表示') {
        widgetCode += ` data-readmore="${this.loadMoreText}"`
      }

      if (this.defaultLimitCount !== 12) {
        widgetCode += ` data-limit="${this.defaultLimitCount}"`
      }

      if (this.isViewMessage) {
        widgetCode += ' data-is-view-message="true"'
      }

      widgetCode += '></div>'

      this.widgetCode = widgetCode
    },

    /**
     * ウィジェットデータを取得
     */
    async getWidgets() {
      const { data } = await api.get('/widgets', {
        params: {
          campaignId: this.campaign.id,
          limitCount: this.maxLimitCount
        }
      })

      if (data) {
        this.widgets = data
      }
    },

    /**
     * ウィジェットデータの作成
     */
    async createWidget() {
      TrackingService.sendEvent(
        `click:応募履歴|ウィジェット管理(${this.snsType === 'twitter' ? 'X' : 'IG'})|ウィジェットデータの生成`
      )

      if (this.isSubmit) {
        return
      }

      this.isSubmit = true

      const result = await api.post('/widgets', {
        campaignId: this.campaign.id
      })

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (result.error || !result.data) {
        this.isSubmit = false
        this.$notify({
          title: 'ウィジェットデータの作成に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      this.$notify({
        title: 'ウィジェットデータを作成しました。',
        customClass: 'success',
        duration: 5000
      })

      this.$emit('widget_added')

      await this.getWidgets()
    },

    /**
     * リセット
     */
    reset() {
      this.widgets = []
      this.isSubmit = false
      this.defaultLimitCount = 12
    },

    /**
     * 閉じる前にデータをリセット
     */
    beforeClose() {
      TrackingService.sendEvent(`select:応募履歴|ウィジェット管理(${this.snsType === 'twitter' ? 'X' : 'IG'})|閉じる`)

      this.visible = false
      this.reset()
    },

    /**
     * 続きを表示をクリック
     */
    clickLoadMore() {
      this.displayCount = this.displayCount + this.defaultLimitCount
    },

    handleDefaultLimitCount() {
      if (this.defaultLimitCount === this.displayCount + 1) {
        TrackingService.sendEvent(
          `click:応募履歴|ウィジェット管理(${this.snsType === 'twitter' ? 'X' : 'IG'})|表示件数|UP`
        )
      } else if (this.defaultLimitCount === this.displayCount - 1) {
        TrackingService.sendEvent(
          `click:応募履歴|ウィジェット管理(${this.snsType === 'twitter' ? 'X' : 'IG'})|表示件数|DOWN`
        )
      } else
        TrackingService.sendEvent(
          `input:応募履歴|ウィジェット管理(${this.snsType === 'twitter' ? 'X' : 'IG'})|表示件数`
        )
    },

    onChangeLoadMoreText() {
      TrackingService.sendEvent(
        `input:応募履歴|ウィジェット管理(${this.snsType === 'twitter' ? 'X' : 'IG'})|続きを表示ボタンのテキスト`
      )
    }
  }
})
</script>
<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.description {
  color: $sub-text-color;
}

.text-bold {
  color: $text-color;
}

.no-resize {
  textarea {
    resize: none;
  }
}

.widget-item {
  display: inline-block;
  width: 25%;
  height: $spacing-unit * 30;
}

.button-container {
  text-align: center;

  .el-button--large {
    padding: $spacing-unit $spacing-unit * 5;
  }
}

.loadmore-text {
  width: $spacing-unit * 20;
}

.form-label {
  font-weight: bold;
}

.campaign-container {
  padding: $spacing-unit * 2;
  border: 1px solid $border-color;
  border-radius: math.div($spacing-unit, 2);
}
</style>
